import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card, Table, Button, Tag, Tooltip, Typography, Modal, message, Select, Input } from 'antd'
import { CheckSquareOutlined } from '@ant-design/icons';

import { req_page_ars_qualifyDivision, req_edit_ars_qualify, req_downloadfile_ars_qualify_division } from '../../api'
import { usrRole } from '../../utils/dataUtil'

import { API_BASE, PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'
import { formateDate, getDateYYYYMMDD } from '../../utils/dateUtil'

import ReservationMailModal from './reservation-mail-modal'
import ReservationSelfModal from './reservation-self-modal'
const { Text, Title } = Typography;
class ClaimerSendmailCase extends Component {

    state = {
        loading: false,
        userLevel: 'NORMAL',
        item: {},
        // 分頁參數
        items: [],
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'ApplyCaseDate',
        searchValue: getDateYYYYMMDD(new Date()),
        filterStatus: 'SENDMAIL',
        division: '日間部',

        domnloadFile: '',
        isShowSendMailModal: false,
        isShowOnSiteModal: false,
        isShowLogModal: false
    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        this.api_page_items(1)
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus, division } = this.state
        const { token, userCode, role } = this.props.user

        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        this.setState({ loading: true })
        const result = await req_page_ars_qualifyDivision(userCode, userLevel, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, division, token)
        this.setState({ loading: false })

        // console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })
            //console.log(this.state);
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }

    api_edit_item = async (type, applycase) => {
        const token = this.props.user.token
        //this.setState({ loading: true })
        const result = await req_edit_ars_qualify(applycase, token)
        //this.setState({ loading: false })
        if (result.status === 'success') {
            const word = (type === 'CANCEL') ? '取消成功' : '簽領完成'
            message.success(word)
            this.api_page_items(this.current)
        } else {
            message.error(result.message)
        }
    }

    api_downloadfile_items = async () => {
        const { userLevel, searchField, searchValue, filterStatus, division } = this.state
        const { token, userCode } = this.props.user

        // download file data
        const fileUrl = await req_downloadfile_ars_qualify_division(userCode, userLevel, searchField, searchValue, filterStatus, division, token)

        // download file link      
        let a = document.createElement('a');
        a.href = API_BASE + fileUrl;
        a.target = '_blank'
        a.download = '預約清單';
        a.click();
    }


    // 數據配置設定 ////////////////////////////////////////////// 
    init_columns = () => {
        this.columns = [
            {
                title: '部別',
                dataIndex: 'Division',
                width: 30,
                responsive: ['md'],
                render: (text, item) => {
                    const { Id, Division } = item
                    let color = this.style_switch_color_tag('Division', Division)
                    return (
                        <Tag color={color} key={Id}>
                            <div>{text}</div>
                        </Tag>
                    )
                }
            },
            {
                title: '獎項名稱',
                dataIndex: 'QualifyDscription',
                width: 45,
                render: (text, item) => {
                    return (
                        <>
                            <Text type="warning"><i className="fas fa-award"></i></Text>{' '}<span> {text}</span>
                        </>
                    )
                }
            },
            {
                title: '獲獎人',
                dataIndex: 'EligibleName',
                width: 30,
                render: (text, item) => {
                    const { ArrearsTotal } = item
                    return (
                        <>
                            {ArrearsTotal > 0 ? (
                                <> <Tooltip placement="topLeft" title={`校內待處理計${ArrearsTotal}項`}><Tag color="magenta"><i className="fas fa-bell"></i></Tag></Tooltip>{' '}</>
                            ) : ''}
                            {' '}
                            <span>{text}</span>

                        </>
                    )
                }
            },
            {
                title: '領取狀態',
                width: 40,
                responsive: ['md'],
                render: (item) => {
                    const { EligibleStatus, ReservationType, Id } = item
                    let color = this.style_switch_color_tag('EligibleStatus', EligibleStatus)
                    return (
                        <>
                            <Tag color={color} key={Id}>
                                {(EligibleStatus === 'ACCEPT') ? '未領取' : ''}
                                {(EligibleStatus === 'CASEEND' && ReservationType === 'SENDMAIL') ? '已處理' : ''}
                                {(EligibleStatus === 'CASEEND' && ReservationType === 'ONSITE') ? '已領取' : ''}
                            </Tag>
                        </>
                    )
                }
            },
            {
                title: '申請時間',
                dataIndex: 'CaseCreateDateTime',
                width: 35,
                responsive: ['md'],
                render: (text, item) => {
                    return (
                        <> {formateDate(text)} </>
                    )
                }
            },
            {
                title: '',
                dataIndex: '',
                width: 60,
                render: (item) => {
                    const { EligibleStatus, CaseCode, ReservationType, ReservationLocation, ReservationTimeTag, OverTodoDay, EligiblePhone } = item
                    const timeTag = ReservationTimeTag.substr(4, 2) + '/' + ReservationTimeTag.substr(6, 2) + ' ' + ReservationTimeTag.substr(8, 4) + '-' + ReservationTimeTag.substr(12, 4)
                    return (CaseCode === '0000000000000000') ?
                        (
                            <>
                                <Button type="primary" size='small' onClick={() => this.handle_show_ui_reservation_onsite(item)} ><i className="far fa-calendar-plus"></i><span> 預約自取</span></Button> {' '}
                                <Button type="primary" size='small' onClick={() => this.handle_show_ui_reservation_sendmail(item)} ><i className="fas fa-mail-bulk"></i><span> 預約郵寄</span></Button>
                            </>
                        ) :
                        (
                            (EligibleStatus === 'ACCEPT') ? (
                                <>
                                    <Tooltip placement="topLeft" title="取得後請簽收"><Button size='small' onClick={() => this.handle_show_ui_signfor_check(item)} danger><i className="fas fa-clipboard-check"></i><span> 簽收</span></Button></Tooltip>
                                    <Tooltip placement="topLeft" title="變更獲取方式(或逾期重新預約)"><Button size='small' onClick={() => this.handle_show_ui_cancel(item)} ><i className="far fa-calendar-times"></i><span> 取消</span></Button></Tooltip>
                                    <p />
                                    <div>
                                        {ReservationType === 'ONSITE' && EligibleStatus === 'ACCEPT' && OverTodoDay < 0 ? (<Tag color='Red'>逾期</Tag>) : ''}
                                        {ReservationType === 'ONSITE' && EligibleStatus === 'ACCEPT' && OverTodoDay > 0 ? (<Tag color='Blue'>有效</Tag>) : ''}
                                        {ReservationType === 'ONSITE' && EligibleStatus === 'ACCEPT' && OverTodoDay === 0 ? (<Tag color='Green'>當日</Tag>) : ''}
                                        {ReservationType === 'ONSITE' && EligibleStatus === 'ACCEPT' ? (<Tooltip placement="topLeft" title="請準時前往領取"><Text mark>{timeTag}</Text></Tooltip>) : ''}
                                        {ReservationType === 'SENDMAIL' ? (<><Tag color='Green'>寄送地點</Tag><Text strong>{ReservationLocation}</Text></>) : ''}
                                    </div>
                                    {EligiblePhone ? <Tag color="processing"><a href={`tel:${EligiblePhone}`}><i className="fas fa-mobile-alt"></i> {EligiblePhone}</a></Tag> : ''}
                                </>) : (
                                <>
                                    <Button size='small' onClick={() => this.handle_show_ui_signfor_log(item)}><i className="fas fa-file-signature"></i><span> 簽領紀錄</span></Button><p />
                                    {ReservationType === 'SENDMAIL' ? (<><Tag color='Green'>寄送地點</Tag><Text strong>{ReservationLocation}</Text></>) : ''}
                                </>
                            )


                        )
                },

            },
        ]
    }

    style_switch_color_tag(column, param) {
        switch (column) {
            case 'EligibleStatus':
                switch (param) {
                    case 'ACCEPT':
                        return 'red'
                    case 'CASEEND':
                        return 'green'
                    default:
                        return 'default';
                }
            case 'Division':
                switch (param) {
                    case '日間部':
                        return 'warning'
                    case '進修部':
                        return 'default'
                    default:
                        return 'default';
                }
            default:
                break;
        }
    }

    // 操作互動處理 //////////////////////////////////////////////   
    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        // if (filters) {
        //     const status = [...Object.values(filters).filter(Boolean)][0]
        //     if (status) {
        //         this.setState({ filterStatus: status }, () => {
        //             this.api_page_items(pagination.current)
        //         });
        //     } else {
        //         this.setState({ filterStatus: '' }, () => {
        //             this.api_page_items(pagination.current)
        //         });
        //     }
        // } else {
             this.api_page_items(pagination.current)
        // }
    }

    handle_data_refresh = () => {
        this.api_page_items(this.current)
    }

    handle_data_download = () => {
        this.api_downloadfile_items()
    }

    handle_show_ui_reservation_onsite = (item) => {
        this.setState({ isShowOnSiteModal: true, item })
    }

    handle_show_ui_reservation_sendmail = (item) => {
        this.setState({ isShowSendMailModal: true, item })
    }

    handle_show_ui_signfor_check = (item) => {
        Modal.confirm({
            title: (<>
                <span>您確定已領取 <Title level={4}><Text mark>{item.QualifyDscription}</Text></Title></span>
            </>),
            onOk: () => {
                const { userName } = this.props.user
                const data = {
                    condition: 'SIGNFOR',
                    KeyId: item.KeyId,
                    EligibleStatus: 'CASEEND',
                    CloseReservationName: userName
                    //CloseReservationTime
                }
                this.api_edit_item('CHECK', data)
            }
        })
    }

    handle_show_ui_cancel = (item) => {
        Modal.confirm({
            title: (<>
                <span>您確定重新預約<Text mark>{item.QualifyDscription}</Text>領取方式</span>
            </>),
            onOk: () => {
                const data = {
                    condition: 'CANCEL',
                    KeyId: item.KeyId,
                    CaseCode: item.CaseCode,
                }
                this.api_edit_item('CANCEL', data)
            }
        })
    }

    handle_show_ui_signfor_log = (item) => {
        Modal.success({
            title: '簽領紀錄',
            icon: <CheckSquareOutlined />,
            content: (
                <>
                    <div><Tag color='Green'>簽領人員</Tag>{item.CloseReservationName}</div>
                    <div><Tag color='Green'>簽領時間</Tag>{formateDate(item.CloseReservationTime)}</div>
                </>
            ),
            okText: '確認',
        });
    }

    /////////////////////////////////////////////////////////////     
    render() {
        const { loading, item, items, pagination, isShowSendMailModal, isShowOnSiteModal, division, searchValue } = this.state
        const title = (
            <span>
                <Select value={division} style={{ width: 90 }} onChange={value => this.setState({ division: value })}>
                    <Select.Option value='日間部'>日間部</Select.Option>
                    <Select.Option value='進修部'>進修部</Select.Option>
                </Select>
                <Tooltip placement="bottom" title="申請日期"><Input placeholder="申請日期" style={{ width: 90, margin: '0 5px' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} /></Tooltip>
                <Button type='primary' onClick={() => this.api_page_items(1)}><i className="fas fa-search element-hidden"></i> 查詢</Button>
                {' '}
                <Tooltip placement="bottom" title="重新整理"><Button type='primary' onClick={() => this.handle_data_refresh()}><i className="fas fa-sync-alt"></i></Button></Tooltip>
                {' '}
                <Button type='primary' onClick={() => this.handle_data_download()}><i className="fas fa-cloud-download-alt element-hidden"></i> 下載</Button>
            </span>
        )
        return (
            <Card title={title} >
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='KeyId'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
                <Modal
                    destroyOnClose={true}
                    title="預約郵寄"
                    visible={isShowSendMailModal}
                    width={1000}
                    onOk={() => {
                        this.setState({ isShowSendMailModal: false })
                        this.api_page_items(this.current)
                    }}
                    onCancel={() => {
                        this.setState({ isShowSendMailModal: false })
                    }}
                >
                    <ReservationMailModal qualify={item} />
                </Modal>
                <Modal
                    destroyOnClose={true}
                    title="預約自取"
                    visible={isShowOnSiteModal}
                    width={1000}
                    onOk={() => {
                        this.setState({ isShowOnSiteModal: false })
                        this.api_page_items(this.current)
                    }}
                    onCancel={() => {
                        this.setState({ isShowOnSiteModal: false })
                    }}
                >
                    <ReservationSelfModal qualify={item} />
                </Modal>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ClaimerSendmailCase)